import React from "react";
import toast from "react-hot-toast";
import { handleLogout } from "../utils/helperFunctions";

const PendingApproval = () => {
    const onLogout = () => {
        toast.success("Logged out successfully");
        handleLogout({});
    };

    return (
        <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-50 p-6">
            <div className="w-full max-w-md text-center">
                {/* Logo */}
                <div className="flex items-center justify-center gap-3 mb-8">
                    <img
                        src="/static/images/seekho-logo.png"
                        alt="Logo"
                        className="h-14 w-14"
                        onError={(e) => {
                            e.currentTarget.style.display = "none";
                        }}
                    />
                    <span className="text-3xl font-bold bg-gradient-to-r from-[#5E30BF] to-[#AF30BF] bg-clip-text text-transparent">
                        Seekho
                    </span>
                </div>

                {/* Icon */}
                <div className="mb-6 flex justify-center">
                    <div className="h-24 w-24 bg-yellow-50 rounded-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-12 w-12 text-yellow-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                </div>

                {/* Content */}
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Approval Pending
                </h2>
                <p className="text-gray-500 text-lg mb-8">
                    Your account is currently waiting for admin approval. Please check back
                    later or contact support if you believe this is an error.
                </p>

                {/* Action */}
                <button
                    onClick={onLogout}
                    className="w-full py-3.5 rounded-xl text-white font-medium transition-all duration-200 bg-gradient-to-r from-[#5E30BF] to-[#AF30BF] hover:shadow-lg hover:shadow-primaryPurple/30 hover:scale-[1.01] active:scale-[0.99]"
                >
                    Logout
                </button>
            </div>
        </section>
    );
};

export default PendingApproval;
